/**
 * PATH: packages/ui/src/kanban/utils/csv.ts
 * FILE_ID: UI-KANBAN-UTIL-CSV-001
 * PURPOSE: RFC-4180 CSV cell escaping + row serialisation shared by every
 *          kanban CSV export (card entries, board table).
 * WHY: Extracted from card-detail/entries/entryClipboard.ts (expand-migrate,
 *      not fork) when the board Table view gained its own CSV export —
 *      duplicating the quoting logic is how exports drift apart.
 */

/** Quote a cell iff it contains a comma, quote, or newline; embedded
 *  quotes double per RFC 4180. Verbatim move from entryClipboard.ts. */
export function csvCell(value: string): string {
  return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value
}

/** rows → one CSV string (no trailing newline), every cell escaped. */
export function rowsToCsv(rows: readonly (readonly string[])[]): string {
  return rows.map((row) => row.map(csvCell).join(',')).join('\n')
}

/** Browser download of a CSV string — the house Blob/objectURL pattern
 *  (same shape as CardEntriesSection's export button). */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
